import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, ChangeRequestForm, Container, Content } from '@simplybenefits/sb-ui-library';
import {
    getChangeRequestFile,
    approveChangeRequest,
    declineChangeRequest,
    updateChangeRequest,
    downloadChangeRequestPdf
} from '../../../actions/administration.js';
import { listFiles, createFolder, uploadFile, downloadFile, removeFile } from '../../../actions/files.js';
import Header from '../../../components/Header';
import ResendReviewEmailModal from '../../../components/ChangeRequests/ResendReviewEmailModal';
import permissionLevel from '../../../services/permissions.js';
import * as notifier from '../../../actions/notifier.js';

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
const ChangeRequests = ({ dispatch, match, loader, access }) => {
    const [ isModalOpen, setIsModalOpen ] = useState(false);
    const styles = {
        buttonContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'end',
            marginBottom: '20px'
        }
    };

    const [ changeRequest, setChangeRequest ] = useState(null);
    const breadcrumbs = [
        {
            title: 'Administration',
            link: `/administration`
        }
    ];

    /**
     * 
     * @param {*} changeRequestID 
     * @returns 
     */
    const _fetchChangeRequests = (changeRequestID) => dispatch(getChangeRequestFile(changeRequestID));

    /**
     * @private
     */
    const _downloadPDF = async () => {
        const changeRequestID = match.params.changeRequestID;
        const url = await dispatch(downloadChangeRequestPdf(changeRequestID));
        window.open(url, "_blank");
    };

    /**
     *
     * @param id
     * @param changeRequestFile
     * @returns {*}
     */
    const save = (id, changeRequestFile) => {
        if (!permissionLevel('Administration', access).includes('write')) {
            dispatch(notifier.displayError({
                verbiage: "You are missing permission for saving change requests."
            }));

            return false;
        }

        const body = { changeRequest: changeRequestFile };
        return dispatch(updateChangeRequest(id, body));
    };

    /**
     * 
     * @param {*} submitData 
     * @returns 
     */
    const submit = async (submitData, submitType) => {
        if (!permissionLevel('Administration', access).includes('write')) {
            dispatch(notifier.displayError({
                verbiage: `You are missing permission for ${ submitType === 'Approve' ? 'approving' : 'declining' } change requests.`
            }));

            return false;
        }

        const changeRequestID = match.params.changeRequestID;
        let success = null;
    
        if (submitType === 'Approve') {
            success = await dispatch(approveChangeRequest(changeRequestID, submitData));
        } else if (submitType === 'Decline') {
            success = await dispatch(declineChangeRequest(changeRequestID, submitData));
        }

        if (success) {
            const result = await _fetchChangeRequests(changeRequestID);
            setChangeRequest(result);
            window.scrollTo({ top: 0, behavior: 'smooth' });

            return true;
        }

        return false;
    };


    /**
     *
     * @private
     */
    const _toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    useEffect(async () => {
        const changeRequestID = match?.params?.changeRequestID;
        const result = await _fetchChangeRequests(changeRequestID);
        setChangeRequest(result);
    }, []);

    return (
        <div>
            <Header
                subHeader="Change Requests"
                breadcrumbs={breadcrumbs}
            />
            <Container>
                <Content>
                    <div style={ styles.buttonContainer }>
                        {
                            [ 'Pending Member Review', 'Pending Admin Review' ].includes(changeRequest?.status) &&
                                <Button
                                    onClick={ _toggleModal }
                                    color="primary"
                                >
                                    Resend Review Email
                                </Button>
                        }

                        {
                            [ 'Approved', 'Declined' ].includes(changeRequest?.status) &&
                                <Button
                                    onClick={ _downloadPDF }
                                    color="primary"
                                >
                                    Download PDF
                                </Button>
                        }

                    </div>
                    {
                        changeRequest ?
                            <ChangeRequestForm
                                data={ changeRequest }
                                accessType={ 'Agent' }
                                agentWriteAccess={ permissionLevel('Administration', access).includes('write') }
                                approveChangeRequest={ (...params) => submit(...params, 'Approve')}
                                declineChangeRequest={ (...params) => submit(...params, 'Decline')}
                                saveChangeRequest={ (...params) => save(match?.params?.changeRequestID, ...params) }
                                loader={ loader }

                                // Files
                                type="users"
                                id={ changeRequest.userID }
                                dispatch={ dispatch }
                                listFiles={ listFiles }
                                createFolder={ createFolder }
                                uploadFile={ uploadFile }
                                downloadFile={ downloadFile }
                                removeFile={ removeFile }
                            />
                            :
                            null
                    }

                    {
                        isModalOpen ?
                            <ResendReviewEmailModal
                                changeRequestID={ match?.params?.changeRequestID }
                                onClose={ _toggleModal }
                                loader={ loader }
                                dispatch={ dispatch }
                            />
                            : null
                    }
                </Content>
            </Container>
        </div>
    );
};

/**
 * @param state
 * @returns {{loading: *}}
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    access: state.master.access
});

export default connect(mapStateToProps)(ChangeRequests);